import React from "react";

export default function Footer() {
  return (
    <footer className="bg-sprouts-slate text-white mt-12" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-10 text-center">
        <p className="text-base font-extrabold mb-1">Sprouts Edu Tours</p>
        <p className="text-sm text-slate-400">India's Young Travel Storytelling Championship 2026</p>
        <p className="text-xs text-slate-500 mt-3">© 2026 Sprouts Edu Tours. All rights reserved.</p>
      </div>
    </footer>
  );
}
